"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createHost = exports.update = exports.create = exports.fetch = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const terminalService_1 = require("./service/terminalService");
const Env_1 = require("../../utils/tsUtils/Env");
exports.fetch = (0, toolkit_1.createAsyncThunk)("terminalOffline/fetch", (fetchPayload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const terminalService = new terminalService_1.TerminalService(Env_1.APIPATHENV);
        const response = yield terminalService.fetchOfflineTerminal(fetchPayload);
        return response;
    }
    catch (err) {
        throw new Error("Error in fetching terminal offline list");
    }
}));
exports.create = (0, toolkit_1.createAsyncThunk)("terminalOffline/create", (createPayload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const terminalService = new terminalService_1.TerminalService(Env_1.APIPATHENV);
        const response = yield terminalService.createOfflineTerminal(createPayload);
        return response;
    }
    catch (err) {
        throw new Error("Error in creating terminal offline");
    }
}));
exports.update = (0, toolkit_1.createAsyncThunk)("terminalOffline/update", (updatePayload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const terminalService = new terminalService_1.TerminalService(Env_1.APIPATHENV);
        const response = yield terminalService.updateTerminal(updatePayload);
        return response;
    }
    catch (error) {
        throw new Error(error);
    }
}));
exports.createHost = (0, toolkit_1.createAsyncThunk)("terminalOffline/createHost", (createPayload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const terminalService = new terminalService_1.TerminalService(Env_1.APIPATHENV);
        const response = yield terminalService.createHostTerminal(createPayload);
        return response;
    }
    catch (err) {
        throw new Error(err);
    }
}));
